import { render } from "./ResourceDocuments.vue?vue&type=template&id=b33f1c54&scoped=true"
import script from "./ResourceDocuments.vue?vue&type=script&lang=js"
export * from "./ResourceDocuments.vue?vue&type=script&lang=js"

import "./ResourceDocuments.vue?vue&type=style&index=0&id=b33f1c54&scoped=true&lang=css"

import exportComponent from "../../../../../../../../var/www/html/fms_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b33f1c54"]])

export default __exports__